module.exports = __webpack_public_path__ + "fonts/Dosis-Bold.9ed5e842.woff2";